import { Modal } from '@carbon/react';
import { Button } from '@mantine/core';
import { defineMessages, useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import styles from './InitialSetupChoiceModal.module.scss';

type Props = {
    open: boolean;
    onClose: () => void;
    onJoinExisting: () => void;
    onConfigureOwn: () => void;
};

const InitialSetupChoiceModal = ({
    open,
    onClose,
    onJoinExisting,
    onConfigureOwn,
}: Props) => {
    const intl = useIntl();

    return (
        <Modal
            open={open}
            passiveModal
            size="sm"
            modalHeading={intl.formatMessage(messages.title)}
            modalLabel={intl.formatMessage(messages.label)}
            onRequestClose={onClose}
            closeButtonLabel={intl.formatMessage(sharedMessages.close)}
        >
            <p className={styles.description}>
                {intl.formatMessage(messages.description)}
            </p>
            <div className={styles.actions}>
                <Button
                    variant="filled"
                    className={styles.joinExistingButton}
                    onClick={onJoinExisting}
                >
                    {intl.formatMessage(messages.joinExisting)}
                </Button>
                <Button
                    variant="outline"
                    className={styles.configureOwnButton}
                    onClick={onConfigureOwn}
                >
                    {intl.formatMessage(messages.configureOwn)}
                </Button>
            </div>
        </Modal>
    );
};

const messages = defineMessages({
    label: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupChoiceModal.label',
        defaultMessage: 'Pierwsza konfiguracja',
    },
    title: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupChoiceModal.title',
        defaultMessage: 'Jak chcesz rozpocząć?',
    },
    description: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupChoiceModal.description',
        defaultMessage: 'Możesz dołączyć do istniejącej parafii kodem zaproszenia albo skonfigurować własną parafię od początku.',
    },
    joinExisting: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupChoiceModal.joinExisting',
        defaultMessage: 'Dołącz do parafii za pomocą kodu',
    },
    configureOwn: {
        id: 'src.Screens.Dashboard.InitialSetup.InitialSetupChoiceModal.configureOwn',
        defaultMessage: 'Skonfiguruj własną parafię',
    },
});

export default InitialSetupChoiceModal;
